import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Footer from 'src/components/Footer';
import Logo from 'src/components/Items/Logo';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';

interface IProps {
  type: string;
}

const SuccessPage: FC<IProps> = ({ type }) => {
  const contract = useTypedSelector(state => state.contract.contract);
  const navigate = useNavigate();

  return (
    <div className='result-page'>
      <Logo />
      <div
        className={`result-page__main 
        ${type === 'payment' && 'result-page__payment'}
        ${type === 'driver-invite' && 'result-page__driver-invite'}  
        ${type === 'upload' && 'result-page__upload'}`}
      >
        {type === 'driver-invite' && (
          <>
            <p className='result-page__driver-invite__title'>Success, that worked just fine.</p>
            <p>Your additional driver got an email from us to upload their documents.</p>
            <p>
              To learn more visit our&nbsp;
              <a
                href='https://www.sprinter-rentals.com/van-rental-made-easy'
                style={{ textDecoration: 'underline' }}
                target='_blank'
              >
                Quick Guide
              </a>
              &nbsp;&&nbsp;
              <a
                href='https://www.sprinter-rentals.com/van-rental-made-easy'
                style={{ textDecoration: 'underline' }}
                target='_blank'
              >
                Help Chat
              </a>
            </p>
          </>
        )}
        {type === 'upload' && (
          <>
            <p className='result-page__upload__title'>Thank you for uploading your documents!</p>
            <p className='result-page__upload__title'>
              We've emailed a link to add drivers if you'd like.
            </p>
            <p>As your trip gets closer, we'll email you follow-up info.</p>
            <p>(some info isn't available yet as it might change)</p>
            <ul>
              <li>
                <p>E-sign your rental agreement</p>
              </li>
              <li>
                <p>Share your host’s contact details</p>
              </li>
              <li>
                <p>Provide pick-up or delivery instructions</p>
              </li>
            </ul>
            <p>
              For more info visit our&nbsp;
              <a
                href='https://www.sprinter-rentals.com/van-rental-made-easy'
                style={{ textDecoration: 'underline' }}
                target='_blank'
              >
                Quick Guide
              </a>
              &nbsp;&&nbsp;
              <a
                href='https://www.sprinter-rentals.com/van-rental-made-easy'
                style={{ textDecoration: 'underline' }}
                target='_blank'
              >
                Help Chat
              </a>
              .
            </p>
            <p>
              <Link to='/client' style={{ textDecoration: 'underline' }}>
                Login
              </Link>
              &nbsp;anytime to make adjustments.
            </p>
          </>
        )}
        {type === 'signed' && (
          <>
            <p>Thank you for signing your rental agreement for your booking #{contract.id}.</p>
            <p>
              We emailed you a copy with your signed contract your records (printing is optional).
            </p>
            <p>
              You are now good to go. Your host will email or text you Instructions on where to get
              your van and how to unlock it.
            </p>
            <p>
              Your host {contract.host.first_name} {contract.host.last_name}
              <br />
              at {contract.host.phone} is your main point of contact during your rental.
            </p>
          </>
        )}
        {type === 'payment' && (
          <>
            <p>
              Your booking is confirmed.
              <br />
              Please check your confirmation email for accuracy.
            </p>
            <p className='result-page__payment__text'>
              No rental counters! Fully digital check-in process.
              <br />
              You can&nbsp;
              <span onClick={() => navigate('/client')}>log in</span>
              &nbsp;to make changes, manage, pay, or cancel your booking.
              <br />
              We'll email your host's contact and updates a little closer to your trip.
            </p>
          </>
        )}
      </div>
      <p className='result-page__wishing'>Wishing you a great day!</p>
      <div className='result-page_link'>
        {/* <Link to='/' children='Get more vans' /> */}
        {/* <a href='https://sprinter-rentals.com'>Home Page</a> */}
        <Button onClick={() => navigate('/')} variant='contained'>
          Get more vans
        </Button>
        {type === 'payment' && (
          <Button variant='contained'>
            <a href='https://www.sprinter-rentals.com/van-rental-made-easy'>What’s next guide</a>
          </Button>
        )}
        <Button variant='contained'>
          <a href='https://sprinter-rentals.com'>Home Page</a>
        </Button>
      </div>
      <div className='footer'>
        <Footer />
      </div>
    </div>
  );
};

export default SuccessPage;
